import config from 'config'
import { TaskQueue } from '@vue-storefront/core/lib/sync'

export const colorMapping = {
  ordered: 'success',
  shipped: 'info',
  delivered: 'success',
  complete: 'success',
  processing: 'primary',
  preorder: 'primary',
  partial_preorder: 'primary',
  partial_preorder_paid: 'primary',
  cancel_requested: 'info',
  cancelRequested: 'error',
  canceled: 'error',
  cancelled: 'error',
  partialReturned: 'info',
  returnRequested: 'info',
  returned: 'info'
}

export const getOrderStatusColor = status => {
  return colorMapping[status] || 'primary'
}

export const getOrder = orderId => {
  const url = config.users.order_endpoint.replace('{{orderId}}', orderId)
  return TaskQueue.execute({
    url,
    payload: {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    }
  })
    .then(response => {
      if (parseInt(response.resultCode) !== 200) {
        throw new Error('Failed to fetch order details')
      }
      return response.result
    })
    .catch(error => {
      console.error('Failed to fetch order details:', error)
      throw error
    })
}
